<template>
    <div class="m-4">

        <router-link to="/user/places">{{$t('back_to_places_list')}}</router-link><br>

        <div class="h3" v-if="imported">Your places will appear in a few seconds</div>

        <div v-if="!imported">
            <h4>{{$t('import_places_from_a_csv_file')}}</h4><br>
            <li>{{$t('column_name_column_address_3rd_type')}}</li>
            <li>{{$t('type_places_example')}}</li>
            <li>serial(s) (optional)</li>

            <br>

            <table class="table w-90 p-2" style="background-color: #eee;max-width: 600px;">
                <tr>
                  <th>NAME</th><th>ADDRESS</th><th>TYPE</th><th>SERIALS</th>
                </tr>
              <tr>
                    <td>Place</td><td> 2 avenue de la République ....</td><td>store</td><td>serial1 serial2</td>
                </tr>
                <tr>
                    <td>...</td><td>...</td><td>...</td><td>...</td>
                </tr>
            </table>
            <div v-if="error">{{error}}</div>
            <div class="p-4">
                <div class="form horizontal">
                    <div class="form-group row">
                        <label class="col-sm-4 col-lg-2 col-form-label text-right">{{$t('places_file')}}</label>
                        <div class="col-sm-8 col-lg-10">
                            <div class="form-group">
                                <input class='input-large' type="file" @change="handleFileUpload($event)">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-8 offset-sm-4 offset-lg-2">
                            <button class="btn btn-primary" v-on:click="submitFile">{{$t('upload')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {HTTP} from '../http-constants'
    import * as nvxlib from '../nvxcommon'

    export default {
        data() {
            return {
                file: '',
                imported: false,
                error: null,
            }
        },
        methods: {
            handleFileUpload(event) {
                this.file = event.target.files[0];
            },
            submitFile() {
                let formData = new FormData();
                var self = this;
                formData.append('file', this.file);
                HTTP.post('/tracker_places/import/', formData, {headers: {'Content-Type': 'multipart/form-data'}})
                    .then(function () {
                        self.imported = true;
                        nvxlib.clearPlaces();
                    })
                    .catch(function () {
                        self.error = "Error importing file"
                    });
            },
        },
        mounted: function () {
        }
    }
</script>
